import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';

interface TileProps {
  children: React.ReactNode;
  title: string;
}

export const SalesRepTile: React.FC<TileProps> = ({ children, title }) => {
  const [styles] = useStyles();
  return (
    <View style={styles.base}>
      <Text style={styles.titleTextStyle}>{title}</Text>
      {children}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.tileColor,
    borderRadius: 8,
    marginBottom: 8,
    padding: 16,
  },
  titleTextStyle: {
    color: theme.colors.primary,
    fontFamily: theme.fonts.primarySemiBold,
    fontSize: 18,
  },
}));
